import readFile from './ReadFile';
export default readFile;
